<template>
  <div class="project-actions">
    <div class="buttons actions-btns">
      <a
        v-if="$route.name === 'therm'"
        @click="detect_form_popup = true"
        class="button is-small is-danger"
      >
        <span class="icon">
          <i
            class="fas"
            :class="{
              'fa-spinner fa-spin': project_status.detect == 0,
              'fa-crosshairs':
                !project_status.detect ||
                project_status.detect == 1 ||
                project_status.detect == -1,
            }"
          ></i>
        </span>
        <span>Detect</span>
      </a>
      <a
        v-if="$route.name === 'therm'"
        @click="approve_form_popup = true"
        class="button is-small is-success"
      >
        <span class="icon">
          <i
            class="fas"
            :class="{
              'fa-spinner fa-spin': project_status.approve == 0,
              'fa-check':
                !project_status.approve ||
                project_status.approve == 1 ||
                project_status.approve == -1,
            }"
          ></i>
        </span>
        <span>Approve</span>
      </a>
      <template v-if="!is_next_tracker">
        <a
          v-if="active_project"
          @click="list_model_popup = true"
          class="button is-small is-success"
        >
          <span>Predict</span>
        </a>
        <a
          v-if="active_project"
          @click="train_data_popup = true"
          class="button is-small is-primary"
        >
          <span>Train Model</span>
        </a>
      </template>
      <a
        v-if="active_project"
        :disabled="!active_project.save"
        @click="save('save')"
        class="button is-small is-info"
      >
        <span class="icon">
          <i
            class="fas"
            :class="{
              'fa-spinner fa-spin': loaders['save'],
              'fa-save': !loaders['save'],
            }"
          ></i>
        </span>
        <span>Save</span>
      </a>
      <a
        v-if="active_project"
        :disabled="!active_project.add"
        @click="save('add')"
        class="button is-small is-warning"
      >
        <span class="icon">
          <i
            class="fas"
            :class="{
              'fa-spinner fa-spin': loaders['add'],
              'fa-plus': !loaders['add'],
            }"
          ></i>
        </span>
        <span>Insert</span>
      </a>
    </div>
    <b-modal :active.sync="detect_form_popup" :width="550" scroll="keep">
      <div class="card import-file" style="border-radius: 10px">
        <div class="card-content form">
          <div class="columns">
            <div class="column">
              <p class="form__label label">Ortho Angle</p>
              <input
                v-model="form.angle"
                placeholder="Ortho Angle"
                class="form__input"
                type="text"
              />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <p class="form__label label">Slug</p>
              <input
                v-model="form.slug"
                placeholder="Slug"
                class="form__input"
                type="text"
              />
            </div>
          </div>
        </div>
        <div class="card-footer">
          <a
            v-if="!is_loading"
            @click="initiate_issue_detection"
            class="card-footer-item"
            >Detect</a
          >
          <a v-if="is_loading" class="card-footer-item">
            <i class="fa fa-spinner fa-spin"></i>
          </a>
          <a class="card-footer-item" @click="detect_form_popup = false"
            >Cancel</a
          >
        </div>
      </div>
    </b-modal>
    <b-modal :active.sync="approve_form_popup" :width="550" scroll="keep">
      <div class="card import-file" style="border-radius: 10px">
        <div
          class="card-content form"
          style="padding: 2rem; height: 30rem; overflow-y: scroll"
        >
          <div class="columns">
            <div class="column">
              <p class="form__label label">Block Number</p>
              <input
                v-focus
                v-model="form.block_number"
                placeholder="Block Number"
                class="form__input"
                type="text"
              />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <p class="form__label label">Customer</p>
              <input
                v-model="form.customer"
                placeholder="Customer"
                class="form__input"
                type="text"
              />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <p class="form__label label">Site</p>
              <input
                v-model="form.site"
                placeholder="Site"
                class="form__input"
                type="text"
              />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <p class="form__label label">Thermal Inspection Date</p>
              <input
                v-model="form.thermal_inspection_date"
                placeholder="Thermal Inspection Date"
                class="form__input"
                type="date"
              />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <p class="form__label label">Visual Inspection Date</p>
              <input
                v-model="form.visual_inspection_date"
                placeholder="Visual Inspection Date"
                class="form__input"
                type="date"
              />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <p class="form__label label">Project Manager</p>
              <input
                v-model="form.project_manager"
                placeholder="Project Manager"
                class="form__input"
                type="text"
              />
            </div>
          </div>

          <b-collapse class="card" :open="true" aria-id="contentIdForA11y3">
            <div
              slot="trigger"
              slot-scope="props"
              class="card-header"
              aria-controls="contentIdForA11y3"
            >
              <p class="card-header-title">Details</p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
              </a>
            </div>
            <div class="card-content">
              <div class="columns">
                <div class="column">
                  <p class="form__label label">Ortho Angle</p>
                  <input
                    v-model="form.angle"
                    placeholder="Ortho Angle"
                    class="form__input"
                    type="text"
                  />
                </div>
                <div class="column">
                  <p class="form__label label">Raw Image Offset (X,Y)(m)</p>
                  <input
                    v-model="form.error"
                    placeholder="x,y"
                    class="form__input"
                    type="text"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <p class="form__label label">Slug</p>
                  <input
                    v-model="form.slug"
                    placeholder="Slug"
                    class="form__input"
                    type="text"
                  />
                </div>
              </div>
              <span class="form__label label">Module Slots -</span>
              <div class="columns">
                <div class="column is-1 v-centered">
                  <span class="form__label label">Type</span>
                </div>
                <div class="column">
                  <p class="control has-icons-left has-icons-right">
                    <a class="button is-borderless">
                      <b-radio
                        v-model="form.module_slots.type"
                        native-value="horizontal"
                        type="is-info"
                        >Horizontal</b-radio
                      >
                    </a>
                    <a class="button is-borderless">
                      <b-radio
                        v-model="form.module_slots.type"
                        native-value="vertical"
                        type="is-info"
                        >Vertical</b-radio
                      >
                    </a>
                  </p>
                </div>
              </div>
              <div class="module-slots">
                <div class="columns">
                  <div class="column">
                    <p class="form__label label">Length</p>
                  </div>
                  <div class="column">
                    <p class="form__label label"># of Rows</p>
                  </div>
                  <div class="column">
                    <p class="form__label label"># of Columns</p>
                  </div>
                  <div class="column is-1"></div>
                </div>
                <div
                  class="columns"
                  v-for="(module_slot, i) in form.module_slots.slots"
                  :key="i"
                >
                  <div class="column">
                    <input
                      v-model="module_slot.length"
                      placeholder="Length"
                      class="form__input"
                      type="number"
                    />
                  </div>
                  <div class="column">
                    <input
                      v-model="module_slot.num_modules_vertical"
                      class="form__input"
                      type="number"
                    />
                  </div>
                  <div class="column">
                    <input
                      v-model="module_slot.num_modules_horizontal"
                      class="form__input"
                      type="number"
                    />
                  </div>
                  <div class="column is-1">
                    <a
                      v-if="form.module_slots.slots.length > 1"
                      @click="remove_module_slot(i)"
                      class="button is-borderless"
                    >
                      <i class="has-text-danger fa fa-times"></i>
                    </a>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <a
                      @click="add_module_slot"
                      class="button is-small is-borderless"
                    >
                      <span class="icon">
                        <i class="fa fa-plus"></i>
                      </span>
                      <span>ADD</span>
                    </a>
                  </div>
                </div>
              </div>

              <p class="form__label label">Module Size -</p>
              <div class="columns">
                <div class="column is-2 v-centered">
                  <p class="form__label label">Width</p>
                </div>
                <div class="column">
                  <input
                    v-model="form.module_size.width"
                    placeholder="Width"
                    class="form__input"
                    type="number"
                  />
                </div>
                <div class="column is-2 v-centered">
                  <p class="form__label label">Height</p>
                </div>
                <div class="column">
                  <input
                    v-model="form.module_size.height"
                    placeholder="Height"
                    class="form__input"
                    type="number"
                  />
                </div>
              </div>
              <div class="field">
                <b-checkbox
                  size="is-small"
                  type="is-black"
                  v-model="form.count_columns_first"
                  >COUNT COLUMNS FIRST</b-checkbox
                >
              </div>
              <div class="field">
                <b-checkbox
                  size="is-small"
                  type="is-black"
                  v-model="form.extract_visual_raw_images"
                >
                  EXTRACT VISUAL RAW IMAGES</b-checkbox
                >
              </div>
              <div class="field">
                <b-checkbox
                  size="is-small"
                  type="is-black"
                  v-model="form.no_report"
                  >NO REPORT</b-checkbox
                >
              </div>
              <div class="field">
                <b-checkbox
                  size="is-small"
                  type="is-black"
                  v-model="form.thermlite_report"
                  >THERMLITE REPORT</b-checkbox
                >
              </div>
              <div class="field">
                <b-checkbox
                  size="is-small"
                  type="is-black"
                  v-model="form.retain_temp_diff"
                  >RETAIN TEMPERATURE DIFFERENCE</b-checkbox
                >
              </div>
              <!-- String Numbering -->
              <p class="form__label label">String Numbering -</p>
              <div class="columns">
                <div class="column">
                  <div class="block">
                    <b-radio
                      v-model="form.string_numbering.type"
                      name="name"
                      native-value=""
                    >
                      None
                    </b-radio>
                    <b-radio
                      v-model="form.string_numbering.type"
                      name="name"
                      native-value="basic"
                    >
                      Basic
                    </b-radio>
                    <b-radio
                      v-model="form.string_numbering.type"
                      name="name"
                      native-value="include_module_number"
                    >
                      Basic + Module Number
                    </b-radio>
                    <b-radio
                      v-model="form.string_numbering.type"
                      name="name"
                      native-value="existing_plus_module_number"
                    >
                      Existing+Module Number
                    </b-radio>
                  </div>
                  <div class="block">
                    <p class="form__label">Prefix</p>
                    <input
                      v-model="form.string_numbering.prefix"
                      placeholder="Prefix"
                      class="form__input"
                      type="text"
                    />
                    <p class="form__label">Suffix</p>
                    <input
                      v-model="form.string_numbering.suffix"
                      placeholder="Suffix"
                      class="form__input"
                      type="text"
                    />
                  </div>
                </div>
              </div>

              <!-- Features Required -->
              <p class="form__label label">Features Required</p>
              <div class="columns">
                <div class="column">
                  <p class="control has-icons-left has-icons-right">
                    <a class="button is-borderless">
                      <input
                        v-model="form.features_required"
                        id="raw-images"
                        value="raw-images"
                        placeholder="Error"
                        class="custom-checkbox"
                        type="checkbox"
                      />
                      <label for="raw-images">Raw images</label>
                    </a>
                    <a class="button is-borderless">
                      <input
                        v-model="form.features_required"
                        id="temperature-difference"
                        value="temperature-difference"
                        placeholder="Error"
                        class="custom-checkbox"
                        type="checkbox"
                      />
                      <label for="temperature-difference"
                        >Temperature Difference</label
                      >
                    </a>
                  
                  </p>
                </div>
                <div class="column">
                  <p class="control has-icons-left has-icons-right">
                    <a class="button is-borderless">
                      <input
                        v-model="form.features_required"
                        id="issue-timestamps"
                        value="issue-timestamps"
                        placeholder="Error"
                        class="custom-checkbox"
                        type="checkbox"
                      />
                      <label for="issue-timestamps">Issue Timestamps</label>
                    </a>
                    <a class="button is-borderless">
                      <input
                        v-model="form.features_required"
                        id="issue-sitemap"
                        value="issue-sitemap"
                        placeholder="Error"
                        class="custom-checkbox"
                        type="checkbox"
                      />
                      <label for="issue-timestamps">Issue sitemap</label>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="card-footer">
          <a
            v-if="!is_loading"
            @click="approve_issue_detection"
            class="card-footer-item"
            >Approve</a
          >
          <a v-if="is_loading" class="card-footer-item">
            <i class="fa fa-spinner fa-spin"></i>
          </a>
          <a class="card-footer-item" @click="approve_form_popup = false"
            >Cancel</a
          >
        </div>
      </div>
    </b-modal>
    <b-modal :active.sync="train_data_popup" :width="700">
      <train-model-popup @close="train_data_popup = false" />
    </b-modal>
    <b-modal :active.sync="list_model_popup" :width="700">
      <list-model-popup @close="list_model_popup = false" />
    </b-modal>
  </div>
</template>
<script>
import SIDV2Service from "@/services/sidv2.service";
import APIService from "@/services/api.service";
import { mapState } from "vuex";
import _ from "lodash";
import TrainModelPopup from "./train-model-popup.vue";
import ListModelPopup from "./predict-model-popup.vue";

export default {
  components: {
    TrainModelPopup,
    ListModelPopup,
  },
  data: function() {
    return {
      loaders: [],
      is_loading: false,
      is_dropup: false,
      //
      apiService: new APIService(),
      sidv2Service: new SIDV2Service(),
      detect_form_popup: false,
      approve_form_popup: false,
      train_data_popup: false,
      list_model_popup: false,
      project_status: {},

      form: localStorage.getItem("approve_issue_detection_form")
        ? JSON.parse(localStorage.getItem("approve_issue_detection_form"))
        : {
            angle: 0.0,
            error: 0.0,
            slug: "",
            module_slots: {
              type: "vertical",
              slots: [
                {
                  length: 0,
                  num_modules_vertical: 0,
                  num_modules_horizontal: 0,
                },
              ],
            },
            module_size: {
              width: 1.8,
              height: 0.9,
            },
            count_columns_first: false,
            extract_visual_raw_images: false,
            no_report: false,
            thermlite_report: false,
            // string_numbers: false,
            retain_temp_diff: false,
            features_required: [],
            string_numbering: {
              type: "",
              prefix: "",
              suffix: "",
            },
            // customer inputs
            customer: "",
            site: "",
            thermal_inspection_date: "",
            visual_inspection_date: "",
            project_manager: "",
            block_number: "",
          },
    };
  },
  created() {
    if (this.$route.name === "therm")
      setInterval(() => {
        if (this.active_project) {
          this.apiService
            .get_project_status({
              id: this.active_project.projectUid,
            })
            .then((res) => {
              if (
                this.project_status &&
                !_.isEqual(this.project_status, res.data)
              ) {
                this.$store.dispatch("set_active_layer", {
                  layer: this.active_project,
                  is_ctrl: true,
                  opacity: 100,
                });
              }
              this.project_status = res.data;
            })
            .catch((err) => {
              if (!err.response) {
                this.$toast.open({
                  message: "Network Error",
                  type: "is-danger",
                });
              } else if (err.response === 403) {
                this.$toast.open({
                  message: "Session Expired, Please Reload the APP",
                  type: "is-danger",
                });
              }
            });
        }
      }, 5000);
  },
  computed: {
    ...mapState([
      "draw",
      "active_project",
      "layer_filtered_features",
      "vectors",
    ]),
    is_next_tracker() {
        return process.env.VUE_APP_DEPLOYMENT === "nxt";
    }
  },
  methods: {
    save(url_key) {
      if (this.active_project && this.active_project[url_key]) {
        let body = {
          geojson: {
            type: "FeatureCollection",
            features: [
              ...this.draw.getAll().features,
              ...this.layer_filtered_features,
            ],
          },
        };
        for (let feature of body.geojson.features) {
          feature.properties.extraProperties = feature.properties
            .extraProperties
            ? feature.properties.extraProperties
            : {};
          let custom_properties =
            _.filter(Object.keys(feature.properties || {}), (key) =>
              key.startsWith("custom_")
            ) || [];
          for (let prop of custom_properties) {
            let key = prop.split("custom_")[1];
            if (!key.length) continue;
            feature.properties.extraProperties[key] = feature.properties[prop];
          }
        }
        this.loaders[url_key] = true;
        this.loaders = Object.assign([], this.loaders);
        this.apiService
          .post_data({ url: this.active_project[url_key], body })
          .then((res) => {
            this.loaders[url_key] = false;
            this.loaders = Object.assign([], this.loaders);
            this.$toast.open({
              message: "Successfully saved features",
              type: "is-success",
            });
          })
          .catch((err) => {
            this.loaders[url_key] = false;
            this.loaders = Object.assign([], this.loaders);
            if (!err.response) {
              this.$toast.open({ message: "Network Error", type: "is-danger" });
            } else {
              this.$toast.open({
                message: "Error saving features",
                type: "is-danger",
              });
            }
          });
      }
    },
    add_module_slot() {
      this.form.module_slots.slots.push({
        length: 0,
        num_modules_vertical: 0,
        num_modules_horizontal: 0,
      });
    },
    remove_module_slot(index) {
      this.form.module_slots.slots.splice(index, 1);
    },
    detect() {
      if (this.active_project) {
        this.apiService
          .post_project_status({
            id: this.active_project.projectUid,
            body: { detect: 0 },
          })
          .then((res) => {
            this.project_status = res.data;
          });
      }
    },
    initiate_issue_detection() {
      this.save("add");
      this.is_loading = true;
      try {
        this.apiService
          .get_data({ url: this.active_project.projectData })
          .then((res) => {
            this.sidv2Service
              .detect({
                body: {
                  data: res.data,
                  callback_url: this.active_project.save,
                  geojson: this.draw.getAll(),
                  details: { ...this.form, projectUID: this.active_project.projectUid },
                },
              })
              .then((res) => {
                this.detect_form_popup = false;
                this.is_loading = false;
                if (this.active_project) {
                  this.apiService
                    .post_project_status({
                      id: this.active_project.projectUid,
                      body: { detect: 0 },
                    })
                    .then((res) => {
                      this.project_status = res.data;
                    });
                }
              })
              .catch((err) => {
                console.log(err);
                this.is_loading = false;
              });
          })
          .catch((err) => {
            console.log(err);
            this.is_loading = false;
          });
      } catch (err) {
        console.log(err);
      }
    },
    approve_issue_detection() {
      this.save("save");
      this.is_loading = true;
      try {
        this.apiService
          .get_data({ url: this.active_project.projectData })
          .then((res) => {
            let geojson = this.draw.getAll();

            geojson.features = geojson.features.map((f) => {
              f.properties["class_config"] =
                this.vectors[f.properties.class_id] || {};
              return f;
            });

            this.sidv2Service
              .approve({
                baseULR: process.env.VUE_APP_SIDV2_API_HOST_APPROVE,
                body: {
                  data: res.data,
                  callback_url: this.active_project.save,
                  geojson,
                  details: { ...this.form, projectUID: this.active_project.projectUid },
                },
              })
              .then((res) => {
                this.approve_form_popup = false;
                this.is_loading = false;
                if (this.active_project) {
                  this.apiService
                    .post_project_status({
                      id: this.active_project.projectUid,
                      body: { approve: 0 },
                    })
                    .then((res) => {
                      this.project_status = res.data;
                    });
                }
              })
              .catch((err) => {
                console.log(err);
                this.is_loading = false;
              });
          })
          .catch((err) => {
            console.log(err);
            this.is_loading = false;
          });
      } catch (err) {
        this.is_loading = false;
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss">
.project-actions {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  z-index: 10;
  .is-dropup-active {
    display: block;
  }
}
.form {
  .module-slots {
    .columns {
      margin-bottom: 0;
    }
  }
  .v-centered {
    display: flex;
    align-items: center;
  }
  .button.is-borderless {
    border: none;
  }
  &__input {
    font-size: 1rem;
    font-family: inherit;
    color: inherit;
    padding: 0.5rem;
    border: none;
    background: #f4f6fb;
    border-radius: 2px;
    border-bottom: 2px solid transparent;
    display: block;
    width: 100% !important;
    transition: all 0.3s;

    &:focus,
    &:hover {
      outline: none;
      box-shadow: 0 1rem 2rem rgba(#cfcfcf, 0.1);
      border-bottom: 2px solid #cfcfcf;
    }
    &:focus:invalid {
      border-bottom: 2px solid #ff7730;
    }
  }

  &__label {
    color: #4a4a4a;
    font-weight: 600;
    font-size: 13px;
    text-transform: uppercase;
    display: block;
  }
  .is-last {
    margin-bottom: 6rem;
  }
}
.custom-checkbox {
  position: relative;
  height: 16px;
  width: 16px;
  margin-right: 0.5rem;
  vertical-align: middle;
  cursor: pointer;
  z-index: 5;

  &::before {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    z-index: 2;
    background-color: #eee;
  }

  &:hover::before {
    background-color: #ccc;
  }

  &::after {
    border-width: 0px 0px 0px 0px;
  }

  &:checked::before {
    background-color: #2196f3;
  }

  &:checked::after {
    position: absolute;
    content: "";
    z-index: 3;
    left: 6px;
    top: 3px;
    width: 5px;
    height: 9px;
    border: solid white;
    border-width: 0px 2px 2px 0px;
    transform: rotate(45deg);
  }
}
</style>
